import Config from "../../config/main";

/**
 * @description Create video request list for available providers.
 * @param providerAvailableEvents
 * @returns {Array}
 */

export function getVideoFilterRequest (providerAvailableEvents) {
    if (Config.main.video.enableOptimization) {
        return {
            video_provider: {'@ne': null}
        };
    }
    let filterList = [],
        idsFilter,
        availableProviders = (Config.main.video && Config.main.video.availableVideoProviderIds) || [],
        availableEvents = (Config.main.video && Config.main.video.getProviderAvailableEventsAndEnableFiltering) || [];

    for (let i = 0, length = availableProviders.length; i < length; i += 1) {
        switch (availableProviders[i]) {
            case 1: // PerformGroup
            case 5: // IMG
            case 25: // dota streaming
            case 28: // Alba solution
                idsFilter = (!availableEvents || !availableEvents.includes(availableProviders[i]) || !providerAvailableEvents || !providerAvailableEvents[availableProviders[i]]) ? {
                    '@gt': 0
                } : {
                    '@in': providerAvailableEvents[availableProviders[i]]
                };
                filterList.push({
                    tv_type: availableProviders[i],
                    video_id: idsFilter
                });
                break;
            case 3: // Unas TV
                idsFilter = (!availableEvents || !availableEvents.includes(availableProviders[i]) || !providerAvailableEvents || !providerAvailableEvents[availableProviders[i]]) ? {
                    '@lt': 0
                } : {
                    '@in': providerAvailableEvents[availableProviders[i]]
                };
                filterList.push({
                    video_id: idsFilter
                });
                break;
            case 6: // Private TV
                filterList.push({
                    video_id2: {
                        '@gt': 0
                    }
                });
                break;
            case 7: // Futsal1
            case 8: // Futsal2
            case 11: // Hockey
            case 12: // futsal3
            case 16: // ua_tv
            case 19: // E-Football
            case 26: // private vivaro
                filterList.push({
                    tv_type: availableProviders[i]
                });
                break;
            case 17: // urakulas_tv
            case 21: // dota streaming
            case 22: // dota streaming
            case 23: // dota streaming
                filterList.push({
                    video_id3: {
                        '@gt': 0
                    }
                });
                break;
            case 15: // VIRTAUL_SPORTS
                filterList.push({
                    tv_type: 15,
                    video_id: {
                        '@gt': 0
                    }
                });
                break;
            case 18: //IMG for topsport
                filterList.push({
                    partner_video_id: true
                });
                break;
            case 999999: // horce racing
                filterList.push({
                    video_id: 999999
                });
                break;
            default:
                break;
        }
    }
    return filterList;
}

/**
 * Checks if game has video
 * @param game
 * @param providerAvailableEvents
 * @returns {*|boolean}
 */
export const hasVideo = (game, providerAvailableEvents) => {
    if (game.is_tf && !Config.main.showItfStatistics) {
        return false;
    }
    let availableProviders = (Config.main.video && Config.main.video.availableVideoProviderIds) || [],
        availableEvents = (Config.main.video && Config.main.video.getProviderAvailableEventsAndEnableFiltering) || [];
    if (Config.main.video.enableOptimization) {
        if (game.video_provider) {
            game.tv_type = game.video_provider[0];
            game.video_id = game.video_provider[1];
            return true;
        }
        game.video_id = undefined;
        return false;
    }
    if ((game.tv_type === 15 || game.tv_type === 29) && game.videoId && availableProviders.includes(game.tv_type)) {
        return true;
    }
    if (game.type === 1) { // games from 'prematch'  can't have video streams
        switch (true) {
            case [1, 5, 25, 28].includes(game.tv_type) && game.video_id && availableProviders.includes(game.tv_type) && (!availableEvents || !availableEvents.includes(game.tv_type) || !providerAvailableEvents || !providerAvailableEvents[game.tv_type] || providerAvailableEvents[game.tv_type].includes(game.video_id)):
                return true;
            case game.video_id < 0 && availableProviders.includes(3) && (!availableEvents || availableEvents.includes(3) || !providerAvailableEvents || !providerAvailableEvents[3] || providerAvailableEvents[3].includes(game.video_id)):
                game.tv_type = 3;
                return true;
            case game.video_id2 && availableProviders.includes(6) && (!game.tv_type || (game.tv_type !== 19 && game.tv_type !== 16)):
                game.video_id = game.video_id2;
                game.tv_type = 6;
                return true;
            case [7, 8, 11, 12, 16, 19, 26].includes(game.tv_type) && availableProviders.includes(game.tv_type):
                return true;
            case game.video_id === 999999 && availableProviders.includes(999999):
                game.tv_type = 999999;
                return true;
            case game.video_id3 && availableProviders.includes(17) && (!game.tv_type || game.tv_type !== 21):
                game.video_id = game.video_id3;
                game.tv_type = 17;
                return true;
            case game.video_id3 && ((game.tv_type === 21 && availableProviders.includes(21)) || (game.tv_type === 22 && availableProviders.includes(22)) || (game.tv_type === 23 && availableProviders.includes(23))):
                game.video_id = game.video_id3;
                return true;
            case game.partner_video_id && availableProviders.includes(24):
                game.video_id = game.partner_video_id;
                game.tv_type = 24;
                return true;
            case game.partner_video_id && availableProviders.includes(18):
                game.video_id = game.partner_video_id;
                game.tv_type = 18;
                return true;
            default:
                break;
        }
    }
    return false;
};
